import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './FloatingWhatsApp.css';

const FloatingWhatsApp = () => {
    const handleWhatsAppClick = () => {
        // Default to Jeddah center
        window.open('https://wa.me/966556838300', '_blank');
    };

    return (
        <div className="floating-whatsapp">
            <button 
                onClick={handleWhatsAppClick} 
                className="whatsapp-float-button"
                aria-label="Contact us on WhatsApp"
            >
                <FaWhatsapp size={32} />
                <span className="whatsapp-tooltip">تواصل معنا</span>
            </button>
        </div>
    );
};

export default FloatingWhatsApp;
